import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Stack } from "@mui/material";
import "./ErrorPage.scss";
import Logo from "../../shared/Logo/Logo";
import HeaderBarcode from "../../shared/HeaderBarcode/HeaderBarcode";
import { useSelector } from "react-redux";

const ErrorPage = () => {
  const { authToken, systemName } = useSelector(
    (state) => state.createUser.user
  );
  const navigate = useNavigate();

  useEffect(() => {
    const redirectTime = setTimeout(() => {
      if (authToken && systemName) {
        navigate("/map");
      } else {
        navigate("/generateInvestigationCode");
      }
    }, 5000);

    return () => {
      clearTimeout(redirectTime);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authToken, systemName, navigate]);

  return (
    <Stack className="loading-screen">
      <Stack className="dotted-background">
        <Stack direction={"column"} className="container header">
          <HeaderBarcode />
        </Stack>
        <Stack
          direction={"column"}
          justifyContent={"space-between"}
          className="container content"
          spacing={2}
        >
          <div className="question-bubble">Who made it?</div>
          <Stack className="mission-info">
            <div className="mission-number">Unexpected Application Error!</div>
            <div className="mission-status">404 Not Found</div>
            <div className="mission-description">
              The page you are looking for is not available. Redirecting in 5
              seconds.
            </div>
          </Stack>
        </Stack>
        <Stack direction={"row"} className="container footer">
          <Logo />
        </Stack>
      </Stack>
    </Stack>
  );
};

export default ErrorPage;
